import Grid from '@mui/material/Unstable_Grid2';
import { Stack } from '@mui/system';

export const Qualidade = () => {
    return(

        <div id="qualidade-top">
            
            <Stack >
                <h2>Qualidade</h2>
                <h4>Conheça nossa Política de Qualidade</h4>
            </Stack>
            <div id='qualidade'>
                <div className="overlay-dark">
                        <Grid container
                            spacing={0} 
                            display="flex" 
                            columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                            <Grid 
                                display="flex" 
                                justifyContent="center" 
                                xs={4} sm={8} md={12} 
                            >
                                <Stack >
                                    <div id="qualidadeText">
                                    <h3>A Pattrol tem o compromisso de fornecer soluções em engenharia com segurança, excelência, confiabilidade e conformidade técnica dos resultados de forma a atender plenamente às expectativas de seus clientes.</h3>

                                    <h3>Para isso buscamos:</h3>

                                    <ul>
                                        <li><b>COMPROMISSO COM A SEGURANÇA  </b> – Assegurar um ambiente de trabalho seguro reduzindo riscos e prevenindo acidentes.</li>
                                        <li><b>SATISFAÇÃO DOS CLIENTES</b> – Atender com qualidade, pontualidade e precisão, garantindo o cumprimento dos requisitos técnicos e contratuais.</li>
                                        <li><b>MELHORIA CONTÍNUA</b> – Aperfeiçoar constantemente nossos processos, infraestrutura e capacitação da equipe, garantindo eficiência e inovação nos serviços prestados.</li>
                                        <li><b>ATENDIMENTO A REQUISITOS LEGAIS E NORMATIVOS</b> – Cumprir rigorosamente as normas e regulamentações aplicáveis ao setor assegurando conformidade e credibilidade dos nossos serviços.</li>
                                    </ul>

                                    </div>
                                </Stack>
                            </Grid>
                        </Grid>
                </div>
            </div>

        </div>

    )
}